export class AuditDetailResponse {
  constructor(paramName, paramValue, updatedBy, updatedAt, activityName) {
    this.paramName = paramName;
    this.paramValue = paramValue;
    this.updatedBy = updatedBy;
    this.updatedAt = updatedAt;
    this.activityName = activityName;
  }
}
